import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('IDX_instance_setting_name', ['name'], {})
@Index('UK_instance_setting_name', ['name'], { unique: true })
@Entity('instance_setting')
export class InstanceSettingEntity<
	TValueModel extends object = object,
> extends BaseEntity {
	@Column('varchar', { name: 'name', unique: true, length: 64 })
	public name!: string;

	@Column('json', { name: 'value', nullable: true })
	public value!: TValueModel | null;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;
}
